<script setup lang="ts">
const nuxtApp = useNuxtApp();
const router = useRouter();
const routeNavigationLoading = useState<boolean>(
  "workers-search-route-loading",
  () => false,
);

let isMounted = false;

function isWorkersSearchRoute(name: unknown) {
  return typeof name === "string" && name.startsWith("workers");
}

onMounted(() => {
  isMounted = true;
});

// Show the results loader only while moving between search routes. Navigating away to a profile, registration, or any other page should never flash the
// search loader over the page that is being left
const removeBeforeEach = router.beforeEach((to, from) => {
  if (!isMounted) return;

  routeNavigationLoading.value =
    isWorkersSearchRoute(from.name) && isWorkersSearchRoute(to.name);
});

const removeLoadingEndHook = nuxtApp.hook("page:loading:end", () => {
  routeNavigationLoading.value = false;
});

onBeforeUnmount(() => {
  isMounted = false;
  removeBeforeEach();
  removeLoadingEndHook();
  routeNavigationLoading.value = false;
});
</script>

<template>
  <div class="flex min-h-screen flex-col bg-white">
    <slot />

    <Footer />
  </div>
</template>
